export default Object.freeze({
  None: 0,
  Minimal: 1,
  Low: 2,
  Medium: 3,
  High: 4,
});
